module.exports = __webpack_public_path__ + "img/no_data.30570b6a.png";